import { Container } from 'reactstrap';
import style from './Header.module.scss';

function Header() {
	return (
    <>
		<Container>
			<div className={style.header}>
				<a href="#" className={style.logo} >
					<img src="./logo-mvot.png" alt="logo" />
				</a>
				<div className={style.title}>Reglas de Codificación de Texto</div>
			</div>
		</Container>
    < hr className={style.line} />
    </>
	);
}

export { Header };
